<template lang='pug'>
div(:class='$style[`cc-shortcut`]')
  div(:class='$style[`cc-shortcut-wrap`]')

    router-link(
      :class='$style[`cc-shortcut-nav`]'
      role='button'
      tabindex='0'
      aria-label='前往線上課程'
      to='/')
      IconChart(:size='20')
      span 儀錶板

    router-link(
      :class='$style[`cc-shortcut-nav`]'
      role='button'
      tabindex='0'
      aria-label='求助 Dr.Cell'
      to='/?v=0')
      IconDrCell(:size='20')
      span 求助 AI

    //- router-link(
    //-   :class='$style[`cc-shortcut-nav`]'
    //-   role='button'
    //-   tabindex='0'
    //-   aria-label='前往報告解說'
    //-   to='/sideeffect/summary')
    //-   IconBlood(:size='20' :color='`#e28a79`')
    //-   span 健檢預測

    //- 開啟快捷功能
    button(
      :class='[$style[`cc-shortcut-nav`], $style[`cc-shortcut-nav-main`]]'
      role='button'
      tabindex='0'
      aria-label='開啟快捷功能'
      @click='handleOpenStartPanel')
      div(:class='$style[`cc-shortcut-nav-setup`]')
        div(:class='$style[`cc-shortcut-nav-setup-btn`]')
          span.font-bold +

    router-link(
      :class='$style[`cc-shortcut-nav`]'
      role='button'
      tabindex='0'
      aria-label='前往血壓血糖'
      to='/sideeffect/blood')
      IconBlood(:size='20' :color='`#e28a79`')
      span 血壓血糖

    //- router-link(
    //-   :class='$style[`cc-shortcut-nav`]'
    //-   role='button'
    //-   tabindex='0'
    //-   aria-label='求助 Dr.Cell'
    //-   to='/?v=0')
    //-   IconDrCell(:size='20')
    //-   span 求助 AI

    router-link(
      :class='$style[`cc-shortcut-nav`]'
      role='button'
      tabindex='0'
      aria-label='建立新紀錄'
      to='/sideeffect/post')
      IconEpro(:size='20')
      span 回報症狀

    //- router-link(
    //-   :class='$style[`cc-shortcut-nav`]'
    //-   role='button'
    //-   tabindex='0'
    //-   aria-label='前往QA問答庫'
    //-   to='/aidoctor')
    //-   IconSearch(:size='20' :color='`#6aa5df`')
    //-   span QA問答

</template>

<script>
import { mapMutations } from 'vuex';

import IconSearch from '../icon/Search';
import IconEpro from '../icon/Epro';
import IconDialog from '../icon/Dialog';
import IconDrCell from '../icon/DrCell';
import IconIdeas from '../icon/Ideas';
import IconChart from '../icon/Chart';
// import IconTranslate from '../icon/Translate';
import IconBlood from '../icon/Blood';

export default {
  components: {
    IconSearch,
    IconEpro,
    IconChart,
    IconDialog,
    IconIdeas,
    IconDrCell,
    IconBlood,
  },

  // data() {
  //   return {
  //   };
  // },

  // mixins: [],

  // beforeCreate() {
  //   this.$OneSignal.init({
  //     appId: 'fab7d6fe-205f-4dab-b6de-9c56b2b8e2b7',
  //   });
  // },

  // created() {
  //   this.$router.onReady(() => {
  //   })
  // },

  methods: {
    ...mapMutations({
      changePopStartupStatus: 'global/POPSTARTUP_STATUS',
    }),

    handleOpenStartPanel() {
      this.changePopStartupStatus({
        active: true,
      });
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../sass/component/page/shortcut.scss';
</style>
